import {
  AWARENESS_MODULE_MODAL,
  CLOSE_MODAL,
} from '../modules/modals/modals.module';
import { setCookie } from '../../utils/dom-utils';

export const awarenessModuleOpener = () => (next) => (action) => {
  /* Disabled for the sell flow but can be applied to another flow easily later.
  if ( action.type === APP_LOADED_FULFILLED &&
      isEmpty(getCookie('seenNewSellExperience')) &&
      coalesce(store.getState().routing.locationBeforeTransitions, { pathname: '' }).pathname.endsWith('/sell') &&
      !isPhone()) {
    setImmediate(() => store.dispatch(openModal(AWARENESS_MODULE_MODAL)));
  } **/
  next(action);
};

export const awarenessModuleRecorder = () => (next) => (action) => {
  if (
    action.type === CLOSE_MODAL &&
    action.payload &&
    action.payload.modalName === AWARENESS_MODULE_MODAL
  ) {
    setCookie('seenNewSellExperience', true, 36500);
  }
  return next(action);
};
